import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=bd6fa412&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6fa412')) {
      api.createRecord('bd6fa412', component.options)
    } else {
      api.reload('bd6fa412', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=bd6fa412&", function () {
      api.rerender('bd6fa412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WYyS7k2OMKA/JS/comp/FavElement.vue"
export default component.exports